
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Footer from "@/components/layout/Footer";
import DashboardContent from "@/components/dashboard/DashboardContent";
import { motion } from "framer-motion";

// Import custom hooks
import { useDashboardData } from "@/hooks/useDashboardData";
import { useAchievementBadges } from "@/hooks/useAchievementBadges";

const Dashboard = () => {
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuth();
  const { forms, recentLeads, isLoading, userProfile } = useDashboardData(user?.id || "");
  const { achievements, earnedCount, totalCount, initialBadgesCompleted } = useAchievementBadges(forms, recentLeads);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login");
      return;
    }

    document.title = "Dashboard | InvestorForm";
  }, [isAuthenticated, navigate]);

  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <main className="flex-grow container-padding py-12 pt-6 md:pt-6">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.15 }}
        >
          <DashboardContent 
            isLoading={isLoading}
            forms={forms}
            recentLeads={recentLeads}
            userProfile={userProfile}
            achievements={achievements}
            earnedCount={earnedCount}
            totalCount={totalCount}
            initialBadgesCompleted={initialBadgesCompleted}
          />
        </motion.div>
      </main>
      <Footer />
    </div>
  );
};

export default Dashboard;
